import React from "react";
import { useSelector } from "react-redux";
import StudentInfo from "../../../../components/sections/CompetitionStatus/shared/StudentInfo/StudentInfo";
import Timer from "../../../../components/ui/timer/Timer";
import Icon from "../../../../components/ui/icons/Icon";
import iconsList from "../../../../components/ui/icons/iconsList";
import ItemBlock from "../../../../components/sections/ContestInfo/itemBlock/ItemBlock";
import classes from "./FinalStudentSection.module.css";

const FinalStudentSection = ({ onEnterFinal ,lockBtnWhenChackIsAllowed}) => {
  
  const { texts } = useSelector((state) => state.translate);

  return (
    <ItemBlock className={classes.wrapper} icon={<StudentInfo />}>
      <div className={classes.Container}>
        <div className={classes.FinalDayButtonWrapper}>
          <button className={classes.finalDayButton} onClick={onEnterFinal} disabled={lockBtnWhenChackIsAllowed} >
            <p className={classes.finalDayButtonText}>{texts?.enterToFinal}</p>
          </button>
        </div>
      </div>
    </ItemBlock>
  );
};

export default FinalStudentSection;
